@if (unfinishedRoomInitialised()) {
  @if (showsOverlay()) {
    <div class="tier-first-overlay" [class.shows-app-background]="showsAppBackground">
      <div class="tier-first-content">
        <app-wager-tier-list
          [allTiers]="allTiersSignal"
          [freeMatches]="freeMatchesSignal"
          [currentTournamentData]="currentTournamentDataSignal"
          [soloTiers]="soloTiersSignal"
          [paymentInFlight]="paymentInFlight"
          [waitingOpponentsStandard]="waitingOpponentsStandard"
          (wagerClickEvent)="onWagerClick($event)"
          (tournamentPlayClickEvent)="onTournamentPlayClick($event)"
          (freeMatchClickEvent)="onFreeMatchClick($event)"
          (soloClickEvent)="onSoloClick()"
          (practiceClickEvent)="onPracticeClick()"
          (localClickEvent)="onLocalClick()"
        />
      </div>
    </div>
  } @else {
    <div class="continue-game-footer">
      <app-countdown-pill
        class="time-remaining"
        [timeRemaining]="unfinishedTimeRemaining()"
        size="small"
      />
      <app-button
        [label]="continueButtonLabel()"
        variant="primary"
        stretch="fill"
        (clickEvent)="continueGameClicked()"
      />
    </div>
  }
}
